export default __webpack_public_path__ + "static/Group 646-b39ee9aafdabe8fbcb0168d3734c22a5.png";